var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNewUserTag = function SvgNewUserTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1066",
    width: 40,
    height: 16,
    rx: 3,
    transform: "translate(-.148)",
    fill: "#8b32f2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7150",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "NEW",
    transform: "translate(3.852 11.5)",
    fontSize: 9.5,
    fontFamily: "Roboto-Bold,Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEW")), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-star",
    d: "M29.988 3.814l-1.155 2.343-2.585.377a.566.566 0 00-.313.966l1.87 1.822-.442 2.578a.566.566 0 00.821.6l2.312-1.223 2.312 1.215a.566.566 0 00.821-.6l-.442-2.57 1.87-1.822a.566.566 0 00-.313-.966l-2.585-.377-1.155-2.343a.567.567 0 00-1.016 0z"
  })))));
};
export default SvgNewUserTag;